import React from "react";
import { IconButton } from "@irati/ui/src/Button";
import IconWrapper from "./IconWrapper";
import { HexCode, ColorPreview, WithMargin } from "./styled";
var ColorPreviewItem = function (_a) {
    var onClick = _a.onClick, itemId = _a.itemId, color = _a.color, isLight = _a.isLight, hexCode = _a.hexCode, _b = _a.selectedId, selectedId = _b === void 0 ? null : _b;
    return (React.createElement(WithMargin, null,
        React.createElement(ColorPreview, { small: true, color: color, selectedId: selectedId, itemId: itemId, onClick: onClick },
            React.createElement(HexCode, null, hexCode)),
        React.createElement(IconWrapper, { onClick: onClick, hide: !(selectedId === itemId) },
            React.createElement(IconButton, { inline: true, icon: "tick", onClick: function () { }, color: isLight ? "black" : "white" }))));
};
export default ColorPreviewItem;
